/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_DuplicateInputs */



/**
* | output |
* | --- |
* | "Duplicate" |
*
* @param {Event_Group_Options_DuplicateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_duplicate = /** @type {((inputs?: Event_Group_Options_DuplicateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_DuplicateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dupliquer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Duplikat")
	if (locale === "it") return /** @type {LocalizedString} */ ("Duplicato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Дубликат")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duplicado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("重複")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डुप्लिकेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duplicado")
	return /** @type {LocalizedString} */ ("Duplicate")
});